import React from 'react';
import tolulope from '../../assets/img/Tolulope_Saliu.jpg';
import classes from './Welcome.module.scss';

const Welcome = () => {
  return (
    <div className={classes.container}>
      <div className={classes.imageContainer}>
        <img className={classes.image} src={tolulope} alt="Tolulope Saliu" />
      </div>
      <div className={classes.content}>
        <h1>Tolulope</h1>
        <p className={classes.text}>A detail-oriented software engineer with about nine years of experience developing effective solutions.</p>
        <div className={classes.links}>
          <a className={classes.link1} href="https://linkedin.com/in/tolulopeSaliu" target="_blank" rel="noreferrer noopener">LinkedIn</a>
            <a className={classes.link2} href="https://github.com/toluls" target="_blank" rel="noreferrer noopener">GitHub</a>

          <div className={classes.topLinks}>
            
          </div>
        </div>
      </div>
    </div>
  );
}

export default Welcome;

